import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv3 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-6436">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-6437"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-6438">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-6439">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-6440">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-6441">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-6442">
          <div className="text-left" data-id="element-6443">HEALTH & WELLNESS</div>
          <div className="text-left sm:text-center" data-id="element-6444">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-6445">GLP-1 SUPPORT</div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-6446">
        <div className="max-w-4xl mx-auto" data-id="element-6447">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-6448">
            PATIENT STORY
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-6449">
            "I Was About To Give Up My GLP-1 Weight Loss Until A Bariatric
            Specialist Revealed What The Shot Was Actually Doing To My Brain"
          </h1>

          <div className="my-6" data-id="element-6450">
            <img src="https://cdn.magicpatterns.com/uploads/bao2rn4NRkKGyXaiJg6Dqg/Untitled_(700_x_500_px)_(3).png" alt="Before and after transformation" className="w-full h-auto rounded-sm" data-id="element-6451" />
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-6452">
            GLP-1 Reward-System Fix Backed By Vanderbilt Research That's Helped
            36,700+ Women Stay On Their Shot — Without The Dread, The Numbness,
            Or The Panic Attacks
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-3 mb-0 pb-5 border-b border-gray-200" data-id="element-6453">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-6454">
              <img src="https://cdn.magicpatterns.com/uploads/dZsfYoUn5AK95fR4SRF9oa/YCyEt6vcI9ES0sqc36Qz6.png" alt="Patient" className="w-full h-full object-cover" data-id="element-6455" />
            </div>
            <div className="flex-1" data-id="element-6456">
              <div className="flex items-center gap-1 mb-1" data-id="element-6457">
                <span className="text-sm font-medium text-gray-900" data-id="element-6458">
                  Written By Celine O'Neill
                </span>
                <BadgeCheck className="h-4 w-4 text-blue-600" data-id="element-6459" />
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-6460">
                Verified GLP-1 User • 11 Months on Treatment
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-6461">
                <div className="flex items-center gap-1" data-id="element-6462">
                  <ClockIcon className="h-3 w-3" data-id="element-6463" />
                  <span data-id="element-6464">12 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-6465">
                  <EyeIcon className="h-3 w-3" data-id="element-6466" />
                  <span data-id="element-6467">28,341 views</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv3;